<template>
  <v-dialog
    :value="dialog"
    :max-width="902"
    :retain-focus="false"
    content-class="p-file-input-dialog"
    scrollable
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card outlined>
      <v-card-title>
        {{ multiple ? $t('components.fileInputDialog.title_multiple') : $t('components.fileInputDialog.title') }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="closeDialog"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="text--primary pt-4 pr-3">
        <div
          v-if="loading"
          class="p-file-input-dialog__loader"
        >
          <v-skeleton-loader
            v-for="n in 5"
            :key="n"
            type="image"
            width="150"
            height="150"
          ></v-skeleton-loader>
        </div>
        <v-item-group
          v-else
          v-model="selection"
          :multiple="multiple"
          class="p-file-input-dialog__item-group"
        >
          <v-item
            v-for="file of files"
            v-slot="{ active, toggle }"
            :key="file.id"
            :value="file"
            class="p-file-input-dialog__item"
            active-class="p-file-input-dialog__item--active"
          >
            <div @click="toggle">
              <v-icon
                v-if="active"
                size="14"
                color="white"
                class="p-file-input-dialog__item-check"
              >
                mdi-check
              </v-icon>
              <p-file-preview
                :file="file"
                :height="150"
                :width="150"
                rounded
                bordered
              ></p-file-preview>
            </div>
          </v-item>
        </v-item-group>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn text tabindex="2" @click="closeDialog">{{ $t('cancel') }}</v-btn>
        <v-btn text color="primary" tabindex="1" @click="submit">
          {{ $t('done') }}
          <span v-if="selection.length" class="pl-1">({{ selection.length }})</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

import PBtnIcon from './PBtnIcon'
import PFilePreview from './PFilePreview'

import dialogMixin from '@/mixins/dialog.mixin'
import objectMixin from '@/mixins/object.mixin'


export default {
  components: {
    PBtnIcon,
    PFilePreview
  },


  mixins: [
    dialogMixin,
    objectMixin
  ],


  props: {
    selectedFiles: {
      type: Array,
      default: () => []
    },
    fileType: {
      type: Number,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    hideFilename: {
      type: Boolean,
      default: false
    }
  },


  data () {
    return {
      loading: true,
      files: [],
      selection: []
    }
  },


  computed: {
    ...mapGetters('project', ['currentProjectId'])
  },


  methods: {
    ...mapActions('file', ['loadFiles']),

    async onDialogOpen () {
      if (!this.files.length) {
        this.loading = true
        this.files = []
        this.files = await this.loadFiles({ projectId: this.currentProjectId, fileType: this.fileType })
        this.loading = false
      }

      if (this.multiple === false) {
        this.selection = null
        if (this.selectedFiles.length) {
          this.selection = this.files.find(x => x.id === this.selectedFiles[0].id)
        }
      } else {
        this.selection = []
        for (const selectedFile of this.selectedFiles) {
          const file = this.files.find(x => x.id === selectedFile.id)
          if (file) {
            this.selection.push(file)
          }
        }
      }
    },

    submit () {
      this.$emit('submit', this.selection)
      this.closeDialog()
    }
  }
}
</script>
